/* 布局 */
//前台
import Layout from "@views/layout";

const gravereplaceRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "gravereplace/list",
        name: "GRAVEREPLACE",
        meta: {
            title: "更换管理员申请",
            keepAlive:true
        },
        component: () => import("@views/business/gravereplace/index.vue"),
    },
        ],
};

export default gravereplaceRouter;
